import { useHistory } from 'react-router-dom';
import { t } from '../../i18n/i18n';
import InviteMembers from '../../assets/createdWorkspace/InviteMembers';
import PersonalizeExperience from '../../assets/createdWorkspace/PersonalizeExperience';
import CustomizeWorkspace from '../../assets/createdWorkspace/CustomizeWorkspace';
import { CONFIGURATION, CONFIGURATION_MEMBERS } from '../../constants/routes';
import './WorkspaceOptions.scss';
import { PartnerWorkspaceRole } from '../../constants/enums';
import WorkspaceHomeButton from '../WorkspaceHomeButton/WorkspaceHomeButton';

const WorkspaceOptions = ({
  hideSecond,
  hideThird,
  hideFourth,
  className,
  currentRole,
  fromHome = false,
}) => {
  const history = useHistory();

  const options = [
    {
      title: 'WORKSPACE_OWNER_SECOND_TITLE',
      subtitle: 'WORKSPACE_OWNER_SECOND_SUBTITLE',
      Icon: InviteMembers,
      path: CONFIGURATION_MEMBERS,
      buttonText: 'WORKSPACE_OWNER_SECOND_BUTTON',
      workspaceRoles: [PartnerWorkspaceRole.OWNER, PartnerWorkspaceRole.ADMINISTRATOR],
      hide: hideSecond,
    },
    {
      title: 'WORKSPACE_OWNER_THIRD_TITLE',
      subtitle: 'WORKSPACE_OWNER_THIRD_SUBTITLE',
      Icon: PersonalizeExperience,
      path: `${CONFIGURATION}?tab=evaluation`,
      buttonText: 'WORKSPACE_OWNER_THIRD_BUTTON',
      workspaceRoles: [PartnerWorkspaceRole.OWNER, PartnerWorkspaceRole.ADMINISTRATOR],
      hide: hideThird,
    },
    {
      title: 'WORKSPACE_OWNER_FOURTH_TITLE',
      subtitle: 'WORKSPACE_OWNER_FOURTH_SUBTITLE',
      Icon: CustomizeWorkspace,
      path: CONFIGURATION,
      buttonText: 'WORKSPACE_OWNER_FOURTH_BUTTON',
      workspaceRoles: [PartnerWorkspaceRole.OWNER, PartnerWorkspaceRole.ADMINISTRATOR],
      hide: hideFourth,
    },
  ];

  return (
    <div
      data-testid="workspace-options-container"
      className={`${className} workspace-options-container`}
    >
      <div
        className={` ${
          fromHome
            ? ' w-100 rounded-bottom workspace-options-home-bar bg-blue-principal'
            : ' mx-auto mt-4 created-workspace-grid-container'
        }`}
      >
        {fromHome && (
          <div className="workspace-option-item p-0">
            <WorkspaceHomeButton />
          </div>
        )}
        {options
          .filter((item) => !item.hide)
          .map(({ title, subtitle, Icon, path, buttonText, workspaceRoles }, index) =>
            fromHome ? (
              <button
                key={index}
                type="button"
                style={{ color: '#FFFFFF' }}
                disabled={!workspaceRoles.includes(currentRole)}
                onClick={() => {
                  history.push(path);
                }}
                className="workspace-option-item complete-profile-button font-weight-500 text-sm custom-border-end justify-content-center align-items-center d-flex flex-column py-2 bg-transparent outline-none cursor-pointer"
              >
                {t(title)}
              </button>
            ) : (
              <div
                data-testid="workspace-option"
                className="w-100 bg-white d-flex flex-column text-center align-items-center b-radius-8 p-2"
              >
                <Icon className="mt-4 mb-2" />
                <span className=" font-weight-700 text-base mb-2">{t(title)}</span>
                <span className=" font-weight-500 text-xs mb-2 px-5">{t(subtitle)}</span>
                <button
                  className="font-weight-700 mt-4 mb-4  text-xs font-bold complete-profile-button mx-auto bg-white"
                  type="button"
                  disabled={!workspaceRoles.includes(currentRole)}
                  onClick={() => {
                    history.push(path);
                  }}
                >
                  {t(buttonText)}
                </button>
              </div>
            )
          )}
      </div>
    </div>
  );
};

export default WorkspaceOptions;
